export const submitReviewOwnTeamOverBudgetDialogTitle = 'You have gone over your team\'s budget.';

export const submitReviewOtherTeamOverBudgetDialogTitle = 'You have gone over this team\'s budget.';

export const submitReviewDialogTitle = 'Send team for review';

export const sendBackDialogTitle = 'Send team back for review';

export const approveDialogTitle = 'Approve team decisions';

// tslint:disable-next-line:max-line-length
export const nextWorkflowForwardDescriptionText = 'Your team will be locked and further changes cannot be made unless the team is sent back. The next reviewer will be notified by email with your comments. They will either send it to the next reviewer or send it back to you for changes.';

// tslint:disable-next-line:max-line-length
export const nextWorkflowBackDescriptionText = 'The reviewer will be notified by email with your comments. After making changes, they will resend the team for review.';

// tslint:disable-next-line:max-line-length
export const nextWorkflowApproveDescriptionText = 'Decision will be locked and no further changes can be made. A team cannot be reopened once approved. Once all teams are approved, close the cycle to sync all decisions back to Insight Lab.';

export const submitReviewButtonText = 'Send for Review';

export const sendBackButtonText = 'Send Back';

export const approveButtonText = 'Approve';

export const mandatoryCommentText = 'Comments are required when you are over budget';

export const teamsForwardText = 'teams will be sent to the next reviewer';

export const teamsBackText = 'teams will be sent back to the previous reviewer';

export const teamsApprovedText = 'teams will be approved';

export const allTeamsForwardText = 'All employees in your org will be sent to the next reviewer';

export const allTeamsApprovedText = 'All employees in your org will be approved';